export class ZuAbschlag {
    umsatzsteuerkategorie = "S"
    umsatzsteuersatz!: number
    zuAbschlaege: ZuAbschlaege = new ZuAbschlaege()

    get notEmpty(): boolean {
        return (
            this.umsatzsteuersatz !== 0 ||
            this.zuAbschlaege.nachlassNetto !== 0 ||
            this.zuAbschlaege.grundbetragNetto !== 0 ||
            this.zuAbschlaege.prozentsatz !== 0 ||
            this.zuAbschlaege.grund.trim().length > 0 ||
            (this.zuAbschlaege.grundCode !== undefined && this.zuAbschlaege.grundCode.trim().length > 0)
        )
    }

    toJSON() {
        return {
            umsatzsteuerkategorie: this.umsatzsteuerkategorie,
            umsatzsteuersatz: this.umsatzsteuersatz,
            zuAbschlaege: {
                nachlassNetto: this.zuAbschlaege.nachlassNetto,
                grundbetragNetto: this.zuAbschlaege.grundbetragNetto,
                prozentsatz: this.zuAbschlaege.prozentsatz,
                grund: this.zuAbschlaege.grund,
                grundCode: this.zuAbschlaege.grundCode,
            },
        }
    }
}

class ZuAbschlaege {
    nachlassNetto!: number
    grundbetragNetto?: number
    prozentsatz?: number
    grund!: string
    grundCode?: string
}
